








import {defineComponent, onMounted, watch} from "@vue/composition-api"
import fitty from "fitty"

export default defineComponent({
  props: {
    options: Object,
    update: Number,
  },
  setup(props, ctx) {
    const fittyId = 'fittyElement-' + String(Math.floor((Math.random() * 100000)))
    let f: any
    let el: any
    const fit = () => f && f.fit()

    watch(() => props.update, () => {
      ctx.root.$nextTick(() => fit())

    })

    onMounted(() => {
      // fitty needs rendered DOM, so we can call it only when
      // component is fully rendered
      ctx.root.$nextTick(() => {
        el = document.getElementById(`${fittyId}`)
        if (el !== null) {
          f = fitty(el, props.options)
        }
      })
    })
    return {fittyId, fit}
  },
})
